import { render } from "./Questionnaire.vue?vue&type=template&id=7b9004a7&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"

import "./Questionnaire.vue?vue&type=style&index=0&id=7b9004a7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9004a7"]])

export default __exports__